import {Button, RadioGroup, Checkbox} from "omoplay";
import {useEffect, useState} from "react";
import ImageForm from "../ImageForm";

const QREditor = ({onChangeType, onChangeLogo, onChangeUsedUid, onChangeClearly}) => {
    const [type, setType] = useState("CIRCLE")
    const [logo, setLogo] = useState()
    const [usedUid, setUsedUid] = useState("disabled")
    const [previewUrl, setPreviewUrl] = useState("")
    const [isClearly, setIsClearly] = useState(false)

    const [qrNaturalWidth, setQrNaturalWidth] = useState(0);
    const [logoNaturalWidth, setLogoNaturalWidth] = useState(0);

    useEffect(() => {
        if (type === "CIRCLE") {
            setPreviewUrl("https://img.headless.co.kr/offline_qr_service/6396e153-fa15-449f-829e-cf2724d42471")
        } else if (type === "ROUNDED_SQUARE") {
            setPreviewUrl("https://img.headless.co.kr/offline_qr_service/31084b1a-eb51-4a45-8fe4-7bb16b12af1d")
        } else if (type === "SQUARE") {
            setPreviewUrl("https://img.headless.co.kr/offline_qr_service/554b526a-0052-4419-9542-94ddabdfa259")
        } else if (type === "CUSTOM") {
            setPreviewUrl("https://img.headless.co.kr/offline_qr_service/035a8a67-13cb-48fe-99c8-099ad5567323")
        }
    }, [type]);

    const logoWidthPercent = (qrNaturalWidth > 0 && logoNaturalWidth > 0)
        ? (logoNaturalWidth / qrNaturalWidth) * 100
        : 0;

    return (
        <div className="flex gap-2">
            <div className="flex-1 flex-col gap-4">
                <div className="font-semibold">QR 생성 방식</div>
                <div className="flex-col gap-2">
                    <div>QR 모양</div>
                    <RadioGroup items={[
                        {label: "부드러운형", value: "CIRCLE"},
                        /*{label: "원형", value: "CUSTOM"},*/
                        {label: "라운드형", value: "ROUNDED_SQUARE"},
                        {label: "사각형", value: "SQUARE"}
                    ]}
                                initChecked={type}
                                onSelected={(value) => {
                                    setType(value)
                                    onChangeType(value)
                                }}
                    />
                </div>
                <div className="flex-col gap-2">
                    <div className="flex-align-center gap-2">
                        <div>로고 첨부</div>
                        <div>
                            <Checkbox item={{label: "로고 주변에는 QR 미생성", value: "clearly"}}
                                      onChecked={(checked) => {
                                          setIsClearly(checked)
                                          onChangeClearly(checked)
                                      }}

                            />
                        </div>
                        {
                            logo && (
                                <Button variants="danger" value="로고 제거" onClick={() => {
                                    setLogo(null)
                                    onChangeLogo(null)
                                }} />
                            )
                        }
                    </div>
                    <ImageForm imageUrl={logo}
                               key={logo}
                               onChangeImageUrl={(url) => {
                                    onChangeLogo(url)
                                    setLogo(url)
                                    setLogoNaturalWidth(0)
                                }}
                               sizeInfo="최대 사이즈 300x300"
                               sizeLimit={{width: 300, height: 300}}
                    />
                </div>
                <div className="flex-col gap-2">
                    <div>고유 식별 ID 포함 여부</div>
                    <RadioGroup items={[{label: "미포함", value: "disabled"}, {label: "포함", value: "enabled"}]}
                                initChecked={usedUid}
                                onSelected={(value) => {
                                    setUsedUid(value)
                                    onChangeUsedUid(value)
                                }}
                    />
                    <div className="text-red-500">* 잘못된 QR코드 인쇄 방지용</div>
                </div>
            </div>
            <div className="flex-1 h-full my-auto">
                <div className="text-red-500">* 생성된 QR은 다를 수 있습니다.</div>
                <div className="relative w-full mx-auto">
                    <img src={previewUrl} alt="qr-preview" className="w-full h-auto"
                         onLoad={(e) => setQrNaturalWidth(e.target.naturalWidth)}
                    />
                    {
                        logo && (
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square flex items-center justify-center"
                                style={{
                                    // 계산된 비율(%)을 너비로 적용합니다.
                                    width: logoWidthPercent > 0 ? `${logoWidthPercent}%` : 'auto',
                                    // 계산 전에는 깜빡임 방지를 위해 투명하게 처리할 수도 있습니다.
                                    opacity: logoWidthPercent > 0 ? 1 : 0
                                }}>
                                <img src={logo} alt="logo" className={`w-full h-full object-contain ${isClearly ? "bg-white" : ""}`}
                                     onLoad={(e) => setLogoNaturalWidth(e.target.naturalWidth)}
                                />
                            </div>
                        )
                    }
                    {
                        usedUid === "enabled" && (
                            <div className="absolute bottom-0 right-0 text-[#ced4de] bg-white px-1 font-semibold text-[25px]">
                                ABCDEFGH
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default QREditor